//  转换成千位符
export const getTranslateNumber = (data) => {
  const ret = (parseFloat(((data - 0) || 0), 10).toFixed(2) - 0).toLocaleString() || data.toString();
  const result = ret === '0' && '0.00' || (ret.indexOf('.') === -1 && `${ret}.00` || ret);
  const nums = result.split('.');
  if (nums[1].length < 2) {
    return `${result}0`;
  }
  return result;
};